const RouteKey = {
  Login: '/login',
  ResetPassword: '/resetPassword',
  Profile: '/profile',
  EditProfile: '/profile/edit',
  Content: '/contents/:id'
}

export default RouteKey
